import React, { createContext, useContext } from 'react';
import { message } from 'antd';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const showToast = (type, text) => {
    messageApi.open({
      type,
      content: text,
      duration: 3.5,
    });
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {contextHolder}
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
